import DecorateContainer from 'components/DecorateContainer';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Utils, { ForgetPwProcess } from 'utils';
import i18nLabels from './Success.i18n';
import SuccessContainer from './SuccessContainer';

export default function Success(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    // const infoSignin = useSelector(signInSelector);
    const resetPwProps = {
        ...props,
        i18nLabels,
        history,
        dispatch,
    };
    if (Utils.protectLine(ForgetPwProcess.CreateNewPwSuccessfully)) {
        return <DecorateContainer {...resetPwProps} childComponent={SuccessContainer} />;
    }
}
